import axios from "axios";
import { API_URL } from "./client-config";
import useCurrentLocale from "../hooks/useLanguage";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (typeof window !== "undefined") {
      const locale = useCurrentLocale(); 
      config.headers["locale"] = locale;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
